import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  standalone: false,
  name: 'safeUrl'
})

export class SafeUrlPipe implements PipeTransform {

  constructor(private domSanitizer: DomSanitizer) { }

  transform(url: string): any {
    return this.domSanitizer.bypassSecurityTrustUrl(url);
  }

}
